import React from 'react';

import { TypographyVariants } from '@lyearn/ui';
import { renderEventImage } from '@/modules/events/views/EventManager/components/ListItemContainer';
import ListItemContent from '@/modules/events/views/EventManager/components/ListItemContainer/ListItemContent';
import { AssignmentTypeEnum, EventUnion, RecurringTypeEnum } from '@/types/schema';

function SessionItem({
  event,
  assignmentType,
  nameVariant,
}: {
  event: EventUnion;
  assignmentType?: AssignmentTypeEnum;
  nameVariant?: TypographyVariants;
}) {
  const Image = renderEventImage(event, 48);

  return (
    <ListItemContent
      showDuration
      Image={Image!}
      assignmentType={assignmentType}
      className="overflow-hidden"
      event={event}
      nameVariant={nameVariant}
      showInstructors={false}
      showRecurringIcon={[
        RecurringTypeEnum.Recurring,
        RecurringTypeEnum.RecurringInstance,
      ].includes(event.recurringCategory!)}
    />
  );
}

export default SessionItem;
